export const GET_EVENT_LEADERBOARD_BEGIN = 'GET_EVENT_LEADERBOARD_BEGIN';
export const GET_EVENT_LEADERBOARD_SUCCESS = 'GET_EVENT_LEADERBOARD_SUCCESS';
export const GET_EVENT_LEADERBOARD_FAIL = 'GET_EVENT_LEADERBOARD_FAIL';

export const PUBLISH_EVENT_LEADERBOARD_BEGIN = 'PUBLISH_EVENT_LEADERBOARD_BEGIN';
export const PUBLISH_EVENT_LEADERBOARD_SUCCESS = 'PUBLISH_EVENT_LEADERBOARD_SUCCESS';
export const PUBLISH_EVENT_LEADERBOARD_FAIL = 'PUBLISH_EVENT_LEADERBOARD_FAIL';
